module.exports = __webpack_public_path__ + "img/gruppenfoto.60d25327.jpg";